module.exports = __webpack_public_path__ + "media/coffee-preferences/roast_light-f63ffa08.png";